import { Grid2 as Grid } from '@mui/material';
import { AccordionForm, AccordionFormPanelProps as Props } from '@react-admin/ra-form-layout';
import { Labeled, NumberInput, SelectInput, TextField, TextInput } from 'react-admin';
import { ReactElement } from 'react';
import { APPROVAL_STATUS, APPROVAL_STATUS_CHOICES } from '../../utils';

export default function ApprovalDetailsSection(props: Omit<Props, 'children'>): ReactElement {
  return (
    <AccordionForm.Panel defaultExpanded {...props}>
      <Grid size={{ xs: 12 }}>
        <Labeled label="Name">
          <TextField source="attributes.name" />
        </Labeled>
      </Grid>
      <SelectInput
        choices={APPROVAL_STATUS_CHOICES}
        defaultValue={APPROVAL_STATUS.APPROVED}
        label="Approval Status"
        source="attributes.approval_status"
      />
      <NumberInput label="Bid CPC (cents)" source="attributes.bid_cents" />
      <TextInput label="Remarks" source="attributes.remarks" multiline />
    </AccordionForm.Panel>
  );
}
